import React from 'react';
import PropTypes from 'prop-types';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import TableUtils from '../../../../../utils/TableUtils';
import 'react-bootstrap-table/css/react-bootstrap-table.css';
import Session from "../../../../../utils/Session";
import {
    RESULTS_PER_PAGE
}
from '../../../../../config';

class ResultadoBusqueda extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            datos: this.processData(props.datos),
            times: Session.getAccessTimes()
        };

        this.checker = null;
        this.setCheckerRef = element => {
            this.checker = element;
        };
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            datos: this.processData(nextProps.datos)
        });
    }

    processData(data) {
        return data;
    }

    onRowClick = (row) => {
        /*this.checker.setTarget(row);
        if (!this.checkMaxTimes()) {
            return;
        }

        this.setState({
            times: Session.incAccessTimes()
        });*/

        this.props.onResultadoSeleccionado(row.cuit);
    }

    goToDetail = () => {
        if (!this.checker.getTarget()) {
            return;
        }

        this.setState({
            times: Session.incAccessTimes()
        });

        let cuit = this.checker.getTarget().cuit;
        this.props.onResultadoSeleccionado(cuit);
    };

    closeModal = () => {
        this.checker.closeModal();
    };

    checkMaxTimes = () => {
        return this.state.times < 50;
    };

    render() {
        const table_options = TableUtils.defaultConfig({ pagination: true },
            {
                onRowClick: this.onRowClick,
                onPageChange: this.props.onPageChange,
                page: this.props.currentPage,
                sizePerPage: RESULTS_PER_PAGE
            });

        return (
            <div>
                <BootstrapTable data={this.state.datos} options={table_options} remote={true}
                                fetchInfo={{ dataTotalSize: this.props.totalDataSize }}
                                pagination>
                    <TableHeaderColumn dataField="razon" dataSort={true}>Apellido y Nombre</TableHeaderColumn>
                    <TableHeaderColumn dataField="cuit" isKey={true} dataSort={true}>CUIT</TableHeaderColumn>
                </BootstrapTable>
            </div>
        );
    }
}

ResultadoBusqueda.propTypes = {
    datos: PropTypes.array,
    onResultadoSeleccionado: PropTypes.func,
    onPageChange: PropTypes.func,
    currentPage: PropTypes.number,
    totalDataSize: PropTypes.number
};

export default ResultadoBusqueda;



// WEBPACK FOOTER //
// ./src/scenes/empresas/components/empresas-busqueda/components/ResultadoBusqueda.js